import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
// import FloatingWhatsApp from './components/FloatingWhatsApp/FloatingWhatsApp'; // Commented out - may use later
import FloatingIcons from './components/FloatingIcons/FloatingIcons';
import HomePage from './pages/HomePage';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';
import AccountDeletionPage from './pages/AccountDeletionPage';
import ConfirmDeletionPage from './pages/ConfirmDeletionPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import { MenuProvider } from './contexts/MenuContext';
import styled from 'styled-components';

const AppContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <LoadingScreen isLoading={isLoading} />
      <MenuProvider>
        <Router>
          <AppContainer>
            <Header />
            <Routes>
              <Route path="/" element={<HomePage isAppLoading={isLoading} />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/account-deletion" element={<AccountDeletionPage />} />
              <Route path="/confirm-deletion" element={<ConfirmDeletionPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            </Routes>
            {!isLoading && <Footer />}
            {/* <FloatingWhatsApp /> */} {/* Commented out - may use later */}
            {!isLoading && <FloatingIcons />}
          </AppContainer>
        </Router>
      </MenuProvider>
    </ThemeProvider>
  );
}

export default App;